import React from 'react'
import { IconButton } from 'rsuite'
import CallIcon from '../../../misc/svg/call'
import { CreateRoom, RoomType } from '../../../misc/domain/room'
import { postUserRoomCreate } from '../../../api/rest'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { envSelector } from '../../../features/environment/environmentSlice'
import { userSelector } from '../../../features/user/userSlice'

const EmergencyButton = ({ label, icon, type }) => {
  const { room } = useAppSelector(userSelector)
  const { user } = useAppSelector(envSelector)
  const dispatch = useAppDispatch()

  const createRoomRequest = () => {
    if (user && !room) {
      // Requests a PRIORITY interpreter (moved to the front of the queue) for an urgent situation.
      // This does NOT dial the emergency service — a human interpreter then contacts the relevant
      // service on the user's behalf and relays the conversation.
      let room: CreateRoom = { user_id: user.uuid, is_emergency: true, invite_users: [], room_type: type }
      dispatch(postUserRoomCreate(room))
    }
  }

  return (
    // clamp()/vh sizing: four cards + heading must fit 100vh even on 768px-tall shop PCs
    // (fixed 20px paddings overflowed there and clipped the bottom card's border).
    <div style={{
      backgroundColor: '#1F3539',
      margin: 'clamp(8px, 1.6vh, 20px) 10%',
      padding: 'clamp(10px, 1.8vh, 20px)',
      borderRadius: 20
    }}>
      <p style={{ fontSize: 'clamp(15px, 2.2vh, 20px)', color: 'white', fontFamily: 'Alegreya Sans' }}>{label}</p>
      <p>
        <img src={icon} alt={label} style={{ width: 'clamp(30px, 4.5vh, 42px)' }}/>
        <IconButton icon={CallIcon} size="md"
                    onClick={createRoomRequest}
                    appearance={'primary'}
                    style={{ backgroundColor: '#D15656', float: 'right' }}>
        </IconButton>
      </p>
    </div>
  )
}

const Emergency: React.FC = () => {
  return (
    // overflowY safety net: if an unusually short viewport still can't fit everything,
    // the column scrolls instead of clipping the last card.
    <div style={{ width: '100%', height: '100vh', backgroundColor: '#28454D', boxSizing: 'border-box', overflowY: 'auto' }}>
      <p style={{
        paddingTop: 'clamp(8px, 1.8vh, 20px)',
        paddingLeft: '10%',
        paddingRight: '10%',
        textAlign: 'center',
        color: 'white',
        fontSize: 'clamp(15px, 2.2vh, 20px)',
        fontWeight: 700,
        fontFamily: 'Alegreya Sans'
      }}>
        ΖΗΤΗΣΤΕ ΔΙΕΡΜΗΝΕΑ ΠΡΟΤΕΡΑΙΟΤΗΤΑΣ ΓΙΑ:
      </p>
      <p style={{
        paddingLeft: '10%',
        paddingRight: '10%',
        textAlign: 'center',
        color: '#B7CBCE',
        fontSize: 'clamp(11px, 1.7vh, 13px)',
        fontFamily: 'Alegreya Sans'
      }}>
        Η εφαρμογή δεν καλεί τις υπηρεσίες έκτακτης ανάγκης. Σας συνδέει με διερμηνέα, ο οποίος
        επικοινωνεί με την αρμόδια υπηρεσία για εσάς.
      </p>
      <EmergencyButton label="ΑΣΘΕΝΟΦΟΡΟ" icon="/img/icons/ambulance.svg" type={RoomType.AMBULANCE}/>
      <EmergencyButton label="ΠΟΛΙΤΙΚΗ ΠΡΟΣΤΑΣΙΑ" icon="/img/icons/civil_protection.svg"
                       type={RoomType.CIVIL_PROTECTION}/>
      <EmergencyButton label="ΑΣΤΥΝΟΜΙΑ" icon="/img/icons/police.svg" type={RoomType.POLICE}/>
      <EmergencyButton label="ΠΥΡΟΣΒΕΣΤΙΚΗ" icon="/img/icons/fire.svg" type={RoomType.FIRE_DEPARTMENT}/>
    </div>
  )
}

export default Emergency
